<template>
  <div v-if="!verified">
      <plans msgtitle="You currently do not have access to Data Sources"
            msgdescription="Please choose a plan to pay to enjoy the Data Sources feature">
      </plans>
  </div>
  <div v-else class="">
    <b-card>
      <!-- <div class="container mb-5">
          <ul class="progressbar">
            <li v-for="index in totalSteps" :class="(step === index) ? 'active' : ''">Step {{index}}</li>
          </ul>
      </div>
      <div class="wrapper-mains">
        <div class="left-align">
          <h2 class="bold center" style="color:#3aac5d;">Make Commponent Step Progress in Vue.js</h2>
          <step-progress-slider :length="5"></step-progress-slider>
        </div>
      </div> -->
      
      <b-progress class="mt-3 mb-3" :value="progress" :max="100" variant="primary"></b-progress>
      <step
        v-if="step === 1"
        position="1"
        title="Create or Select a Project"
        description="Create a new project or select an existing project">
        <b-row>
          <b-col cols :md=12>
            <file-project :step="step" @create="toggleProjectLabel" @success="completeProject()"></file-project>
          </b-col>
          <b-col cols :md=9></b-col>
          <b-col cols :md=3 class="mt-2">
            <b-button v-if="step !== 1" size="md" squared variant="default" @click="previousStep" 
            style="float: right" class="mr-3">
              <span>Previous</span>
            </b-button>
            <b-button v-if="step !== totalSteps && !createProject" size="md" squared variant="info" :disabled="project == null" 
              @click="nextStep" style="float: right">
              <span>Next</span>
            </b-button>
          </b-col>
        </b-row>
      </step>
      <step
        v-if="step === 2"
        position="2"
        :project="project.name"
        title="Upload or Select a File for your Project"
        description="Upload or Select a File containing your data for your project. [Supported file type(s): CSV]">
        <b-row>
          <b-col cols :md=12>
            <b-table
              striped
              hover
              small
              head-variant="dark"
              v-if="!$isMobile()"
              :items="metaList"
              :fields="'type|file|mapping|action'.split('|')">
              <template v-slot:cell(type)="data">
                {{ data.item.name }}
                <i class="text-danger" v-if="data.item.required">*</i>
              </template>
              <template v-slot:cell(file)="data">
                <data-type-entry
                  :meta="data.item"
                  :project="project"
                  :files="fileDetails"
                  @select-file="selectProjectFile">
                </data-type-entry>
                <!-- <b-form-select
                  size="sm"
                  :required="!!data.item.required"
                  v-model="data.item.type"
                  @change="mapColumnsForFile()">
                  <template slot="first">
                    <option :value="null">--Please select column--</option>
                  </template>
                  <option
                    v-for="col in fileDetails"
                    :key="col"
                    :value="col._id">
                    {{ col.originalName }}
                  </option>
                </b-form-select> -->
              </template>
              <template v-slot:cell(mapping)="data">
                <!-- {{mapMetaV1[data.item.type]}} -->
                <b-button
                  size="md"
                  squared
                  variant="outline-primary"
                  class="mr-2"
                  v-if="Object.keys(project.files).indexOf(data.item.type) > -1"
                  @click="changeFileMapping(mapMetaV1[data.item.type])">
                  <span>Map Columns</span>
                </b-button>
                <!-- <b-button
                  size="md"
                  squared
                  variant="primary"
                  @click="selectInitProjectFile()">
                
                  <span>Open file mapping</span>
                </b-button> -->
              </template>
              <template v-slot:cell(action)="data">
                <b-button
                  size="md"
                  squared
                  variant="outline-primary"
                  class="mr-2"
                  @click="uploadFile(data.item)">
                  <!-- <span v-if="file">Change Data File</span> -->
                  <span>Upload file</span>
                </b-button>
                <!-- <b-button
                  size="md"
                  squared
                  variant="primary"
                  @click="selectInitProjectFile()">
                
                  <span>Open file mapping</span>
                </b-button> -->
              </template>
            </b-table>
          </b-col>
          <b-col v-if="$isMobile()" cols :md="12">
            <b-row
              v-for="meta in metaList"
              :key="meta.type"
              head-variant="dark"
              :items="metaList"
              :fields="'type|file|action|mapping'.split('|')">
              <b-card 
                :header="meta.name"
                header-tag="header"
                footer-tag="footer"
                >
                <template #header>
                  <h6>{{meta.name}} <i class="text-danger" v-if="meta.required">*</i></h6>
                </template>
                <!-- <p><strong>File:</strong></p> -->
                <data-type-entry
                  :meta="meta"
                  :project="project"
                  :files="fileDetails"
                  @select-file="selectProjectFile">
                </data-type-entry>

                <template #footer>
                  <b-button
                    size="sm"
                    squared
                    variant="outline-primary"
                    class="mr-2"
                    @click="uploadFile(meta)">
                    <span>Upload File</span>
                  </b-button>
                  <b-button
                    size="sm"
                    squared
                    variant="outline-primary"
                    class="mr-2"
                    v-if="Object.keys(project.files).indexOf(meta.type) > -1"
                    @click="changeFileMapping(mapMetaV1[meta.type])">
                    <span>Map Columns</span>
                  </b-button>
                </template>
              </b-card>
            </b-row>
          </b-col>
          <b-col :cols="6" :md=6>
              <b-button
              v-if="step !== 1"
              size="md"
              squared
              variant="outline-primary"
              class="mr-5"
              @click="previousStep" 
              >
              <span>Previous</span>
            </b-button>
          </b-col>
          <b-col :cols="6" :md=6>
            <b-button
              v-if="step !== totalSteps"
              size="md"
              squared
              variant="info"
              @click="nextStep"
              style="float: right"
              >
              <span>Next</span>
            </b-button>
            
          </b-col>
        </b-row>
      </step>
      <step
        v-if="step === 3"
        position="3"
        title="View Available Insights"
        description="View insights we've automatically generated from your data">
        <!-- <h5>Step 1: Create a Project</h5> -->
        <b-row>
          <b-col :md=4>
            <b-card no-body 
              :title="project.name" 
              bg-variant="primary"
              @click="viewInsights()" style="cursor: point">
              <div class="px-3 py-2">
                <h5>View General Data Insights</h5>
                <h6>{{ project.name || 'Untitled project' }}</h6>
                <b-row align-v="start" class="mt-2">
                  <card-detail name="File(s)" :span="6">
                    <span v-if="true">{{ Object.keys(project.files).length | formatInt }}</span>
                    <i v-else class="fa fa-spin fa-spinner"/>
                  </card-detail>
                  <!-- <card-detail name="File(s)" :span="6">
                    <span v-if="true">{{ Object.keys(project.files).length | formatInt }}</span>
                    <i v-else class="fa fa-spin fa-spinner"/>
                  </card-detail> -->
                  <!-- <card-detail name="Of Portfolio" :span="6">
                    <span v-if="isReady">{{ 100 * count / total | formatMoney }} %</span>
                    <i v-else class="fa fa-spin fa-spinner"/>
                  </card-detail> -->
                  <!-- <card-detail name="Created on" :span="6">
                    <span v-if="createdAt">{{ createdAt |  humanize }}</span>
                    <span v-else>na</span>
                  </card-detail> -->
                </b-row>
                <h6 v-if="project.createdAt"> Created {{ project.createdAt |  humanize }} </h6>
              </div>

              <b-card-footer class="px-2 py-1 bg-white" style="border: none;">
                <b-button
                  v-if="step === totalSteps"
                  size="md"
                  squared
                  variant="outline-info"
                  @click="viewInsights()"
                  style="float: right">
                  <span>General Data Insights</span>
                </b-button>
              </b-card-footer>
            </b-card>
          </b-col>
          <b-col :md=4>
            <b-card no-body 
              :title="project.name" 
              bg-variant="primary"
              @click="viewStandardInsights()" style="cursor: point">
              <div class="px-3 py-2">
                <h5>View Business Headlines</h5>
                <h6>{{ project.name || 'Untitled project' }}</h6>
                <b-row align-v="start" class="mt-2">
                  <card-detail name="File(s)" :span="6">
                    <span v-if="true">{{ Object.keys(project.files).length | formatInt }}</span>
                    <i v-else class="fa fa-spin fa-spinner"/>
                  </card-detail>
                </b-row>
                <h6 v-if="project.createdAt"> Created {{ project.createdAt |  humanize }} </h6>
              </div>

              <b-card-footer class="px-2 py-1 bg-white" style="border: none;">
                <b-button
                  v-if="step === totalSteps"
                  size="md"
                  squared
                  variant="outline-info"
                  @click="viewStandardInsights()"
                  style="float: right">
                  <span>Business Headlines</span>
                </b-button>
              </b-card-footer>
            </b-card>
          </b-col>
        </b-row>
        
        <b-row>
          <b-col :cols="6" :md=6>
            <b-button
              v-if="step !== 1"
              size="md"
              squared
              variant="outline-primary"
              @click="previousStep"
              class="mr-5"
              >
              <span>Previous</span>
            </b-button>
          </b-col>
          <b-col :cols="6" :md=6>
            <b-button
              v-if="step === totalSteps"
              size="md"
              squared
              variant="info"
              @click="viewInsights()"
              style="float: right">
              <span>View insights</span>
            </b-button>
            
          </b-col>
        </b-row>
      </step>
    </b-card>
    <b-row>
      <b-col cols :md=12>
        
      </b-col>
      <b-col cols :md=4>
        
      </b-col>
      <b-col cols v-if="false" :md=4>
        <h5>Step 1: Select operation</h5>
        <b-form-radio-group
          id="btn-radios-2"
          v-model="fileOperation"
          :options="fileOperationOptions"
          buttons
          button-variant="outline-primary"
          size="md"
          name="radio-btn-outline">
        </b-form-radio-group>
      </b-col>
      <b-col v-if="fileOperation == 'new_file'" cols :md=4>
        <!-- <h5>2. Upload New File</h5>
        <b-button
          size="md"
          squared
          variant="primary"
          @click="isFileChangeModalOpen = true">
           <span v-if="file">Change Data File</span> 
          <span>Upload Data File</span>
        </b-button> -->
      </b-col>
      <b-col v-if="fileOperation == 'existing_file'" cols :md=4>
        <h5>2. Select file</h5>
        <b-form-select
            v-model="rawFile"
            :options="files"
            
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            style="max-width: 300px;"
            size="lg"
            @change="isFileTypeModalOpen = true"
            ></b-form-select>
      </b-col>
    </b-row>

    <file-project-modal
      :key="`file-project-${modalKey}`"
      :shown="isProjectModalOpen"
      @success="step = 2"
      @close="isProjectModalOpen = false"/>
    
    <file-type-map-modal
      :key="`file-type-map-${modalKey}`"
      :file="rawFile"
      :meta="mapMeta"
      :shown="isFileTypeModalOpen"
      @close="isFileTypeModalOpen = false"/>
    
    <column-mapping-modal
      :key="`column-map-${modalKey}`"
      :meta="mapMeta"
      :file="mapFile"
      :project="mapProject"
      :shown="isMappingModalOpen"
      @close="isMappingModalOpen = false"/>

    <data-type-modal
      :key="`data-type-${modalKey}`"
      :meta="metaList[0]"
      :shown="isDataTypesModalOpen"
      @close="isDataTypesModalOpen = false"/>

    <data-upload-modal
      :key="`flow-${modalKey}`"
      :meta="mapMeta"
      :project="mapProject"
      :shown="isFileChangeModalOpen"
      @fail="uploadedFileFail"
      @success="uploadedFileSuccess"
      @close="isFileChangeModalOpen = false"/>
  </div>

</template>

<script>
  import SourceHeader from './SourceHeader';
  import FileProject from './FileProject';
  import FileProjectModal from './FileProjectModal';
  import FileTypeMapModal from './FileTypeMapModal';
  import ColumnMappingModal from './ColumnMapModal';
  import DataTypeModal from './DataTypeMapModal';
  import DataUploadModal from './DataUploadModal';
  import AlignMiddle from './AlignMiddle';
  import DataTypeEntry from './DataTypeEntry';
  import {hasAllRequiredEntities} from '../../utils';
  import Step from './Step';
  import StepProgressSlider from './StepProgressSlider';
  import Plans from '../Plans/Plans';
  import CardDetail from '../CardDetail';
  import VueSweetalert2 from 'vue-sweetalert2';
  import swal from 'sweetalert2';
  import axios from 'axios';
  import { fullURL, fetchInsight } from '../../utils';
  import { updateProjectFiles, refreshProjects } from '../../store/files';

  window.Swal = swal;
  
  export default {
    name: 'SourcesV2',
    components: {
      CardDetail,
      Step,
      StepProgressSlider,
      SourceHeader,
      FileProject,
      FileProjectModal,
      FileTypeMapModal,
      ColumnMappingModal,
      DataTypeEntry,
      DataTypeModal,
      DataUploadModal,
      AlignMiddle,
      Plans
        
    },

    data() {
      return {
        tab: 0,
        step: 1,
        totalSteps: 3,
        createProject: false,
        rawFile: null,
        project: this.$store.state.files.activeProject,
        verified: this.$store.state.general.user.verified,

        projectFieldMap: {},
        projectFiles: {},
        meta: null,
        mapMeta: null,
        mapFile: {},
        mapProject: null,
        isReady: false,
        isProjectModalOpen: false,
        isFileTypeModalOpen: false,
        isMappingModalOpen: false,
        isDataTypesModalOpen: false,
        isFileChangeModalOpen: false,
        createNewFileModalOpen: false,
        modalKey: 1,
        // files: [],
        fileOperation: 'new_file',
        fileOperationOptions: [
          {text: 'Upload File', value: 'new_file'},
          {text: 'Select Existing File', value: 'existing_file'}
        ]
      };
    },
    // mounted(){
      // console.log("Verified user is", this.$store.state.general.user.verified);
      // if(!this.$store.state.general.user.verified){
      //     window.location = '/plans';

      // //   Swal.fire({
      // //   icon: 'error',
      // //   title: 'Sorry...',
      // //   text: 'You do not have access to this feature now, choose a plan and pay.',
      // //   }).then((result)=>{
      // //   if(result){
      // //     window.location = '/plans';

      // //   }else{
      // //     window.location = '/plans';

      // //   }
      // // })
      // }
    //    	this.$bvToast.toast('Almost there! We have sent you an email to verify your account', {
		// 	title:'Successful',
		// 	autoHideDelay: 5000000,
		// 	variant: variant,
		// 	solid: true
    //     })
    // },
    created(){
      if(!this.$store.state.general.user.email_verified){
       this.$bvToast.toast('Almost there! We have sent you an email to verify your account. Check your email to verify your account', {
              title: 'Verify Email',
              autoHideDelay: 5000000,
              variant: 'success',
              solid: true
            });

			
		
		}
		
    },
    watch: {
      isMappingModalOpen() {
        console.log("Key: ", this.modalKey);
        this.renewModalKey();
      },
      isDataTypesModalOpen() {
        this.renewModalKey();
      },
      isFileChangeModalOpen() {
        this.renewModalKey();
      },
      createNewFileModalOpen() {
        this.renewModalKey();
      },

      rawFile: function(val) {
        console.log('Raw file: ', val);
        if (!!val) {
          this.file = val;
        }
      },
    },

    methods: {
      renewModalKey() {
        this.modalKey = this.modalKey + 1;
      },

      launchModal() {
        this.isMappingModalOpen = true;
        this.activeMeta = true;
      },

      nextStep() {
        this.step++;
        if (this.step === 2) {
          this.project = this.$store.state.files.activeProject;
        }
      },

      previousStep() {
        this.step--;
      },

      completeProject() {
        this.project = this.$store.state.files.activeProject;
        console.log("P: ", this.project);
        this.nextStep();
      },

      toggleProjectLabel(value, event) {
        this.createProject = value['save'];
      },

      mapColumnsForFile() {
        this.isMappingModalOpen = true;
      },

      getFile(name) {
        var file = null;
        this.$store.state.files.fileList.forEach(f => {
          console.log(f);
          if (f.id === name) {
            file = f;
          }
        });
        return file;
      },

      uploadFile(meta) {
        console.log("Project File Meta: ", meta);
        this.mapMeta = meta;
        this.mapProject = this.project;
        this.isFileChangeModalOpen = true;
        // this.isMappingModalOpen = true;
      },

      changeFileMapping(meta) {
        console.log("Project File Meta: ", meta);
        console.log("Project File Meta: ", this.project);
        this.mapMeta = meta;
        this.mapFile = this.getFile(this.project.files[meta.type]);
        console.log("Project File: ", this.mapFile);
        this.mapProject = this.project;
        this.isMappingModalOpen = true;
      },

      uploadedFileFail(value, event) {
        this.mapMeta = value['meta'];
        this.mapProject = this.project;
        this.isFileChangeModalOpen = false;
        var count = value['rowCount'] - value['recordsLeft'];
        Swal.fire({
          title: "<span style='color: #fff; font-size: 1rem'>Sorry. Your file could not be uploaded because it contains <strong style='color: #fc0; font-size: 1.5rem'>" + count + "</strong> more records than what you have left on your current plan!</span>",
          text: "<span style='color: #fff'></span>",
          icon: 'warning',
          html: true,
          // showDenyButton: true,
          // color: "#fff",
          background: "#3a4149",
          showCancelButton: true,
          confirmButtonColor: '#0d4275',
          cancelButtonColor: '#750d0d',
          confirmButtonText: `Upgrade Plan`,
          denyButtonText: `Cancel`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.$router.push(`/plans`);
          } else if (result.isDenied) {
            // Swal.fire('Changes are not saved', '', 'info')
            this.$bvToast.toast('Sorry. Your file could not be uploaded because it contains ' + count + ' more records than what you have left on your current plan!', {
              title: 'Upload Failed',
              autoHideDelay: 5000000,
              variant: 'danger',
              solid: true
            });
          }
        });
      },
      
      uploadedFileSuccess(value, event) {
        this.mapMeta = value['meta'];
        this.mapProject = this.project;
        let fileExists = false;
        this.$store.state.files.fileList.forEach(f => {
          if (f['_id'] === value['fileID']) {
            this.mapFile = f;
            fileExists = true;
          }
        });
        if (!fileExists) {
          axios.get(fullURL(`/file/${value['fileID']}`))
            .then(({data}) => {
              this.mapFile = data;
              this.fileExists = true;
            }).catch(console.log)
            .finally(() => {
              // this.loading = false;
            })
        }
        this.$store.dispatch(updateProjectFiles(this.project['id'], this.mapMeta.type, value['fileID']))
          .then(() => {
            // this.onSuccess();
            console.log("Project file update successful!");
            refreshProjects();
          })
          .catch(console.log)
          .finally(() => {this.isSaving = false;});
        console.log("Uploaded File: ", this.mapFile);
        this.isFileChangeModalOpen = false;
        this.isMappingModalOpen = true;
      },

      selectInitProjectFile(){
        var filetype = Object.keys(this.project.files)[1]
        this.mapMeta = this.mapMetaV1[filetype];
        this.mapProject = this.project;
        console.log("Meta is ", this.mapMeta);
        console.log("Filetype is ", filetype);
        console.log("project files actually is ", this.project.files[filetype])

        this.mapFile = this.rawFiles.filter(e=>e._id===this.project.files[filetype] )[0];  
        this.projectFiles[filetype] = this.project.files[filetype];
        this.isMappingModalOpen = true;
      },
      
      selectProjectFile(value, event) {
        console.log("Selected Project File: ", value);
        this.projectFiles[value['meta']['type']] = value['fileID'];
        this.mapMeta = value['meta'];
        this.mapProject = this.project;
        this.fileDetails.forEach(f => {
          console.log("File[]: ", f);
          if (f['_id'] === value['fileID']) {
            this.mapFile = f;
          }
        });
        console.log("File: ", this.mapFile);
        this.$store.dispatch(updateProjectFiles(this.project['id'], this.mapMeta.type, value['fileID']))
          .then(() => {
            // this.onSuccess();
            console.log("Project file update successful!");
            refreshProjects();
          })
          .catch(console.log)
          .finally(() => {this.isSaving = false;});
        this.isMappingModalOpen = true;
      },

      viewStandardInsights() {
        // this.$router.push(`/dashboard/${id}?view=insights`);
        this.$router.push(`/business-insights`);
      },

      viewInsights() {
        // this.$router.push(`/dashboard/${id}?view=insights`);
        this.$router.push(`/dashboard`);
      },

      getProjectFilesCount() {
        console.log("A: ", this.projectFiles)
        this.isReady = false;
        let count = 0;
        count = Object.keys(this.project.files).length;
        this.isReady = true;
        return count;
      }
    },

    computed: {
      // file() {
      //   const {type} = this.meta;
      //   return this.$store.getters.getActiveFile(type);
      // },

      fileDetails() {
        var files = [];
        this.$store.state.files.fileList.forEach(file => {
          files.push(file);
        });
        return files;
      },

      rawFiles() {
        return this.$store.state.files.fileList
      },
      
      files() {
        var files = [];
        this.$store.state.files.fileList.forEach(file => {
          files.push(file.originalName);
        });
        return files;
      },

      incompletenessMessage() {
        if (!this.file) {
          return this.meta.required ? 'Please provide a data file' : '';
        } else {
          return false;
          // return hasAllRequiredEntities(this.meta.entities, this.file.fieldMap || {}) ? '' :
          //   'Known column mapping is incomplete';
        }
      },
      
      metaList() {
        return this.$store.state.general.metas;
      },

      progress: function() {
        return Math.ceil(100 / this.totalSteps) * this.step;
      },
      
      mapMetaV1() {
        var map = {};
        this.$store.state.general.metas.forEach(meta => {
          map[meta['type']] = meta;
        });
        return map;
      },
    }
  };
</script>

<style scoped lang="css">
.container{
  width: 100%;
  position: absolute;
  z-index: 1;
}
.progressbar li{
  float: left;
  width: 20%;
  position: relative;
  text-align: center;
}
.progressbar{
  counter-reset: step;
}
.progressbar li:before{
  content:counter(step);
  counter-increment: step;
  width: 30px;
  height: 30px;
  border: 2px solid #bebebe;
  display: block;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  line-height: 27px;
  background: white;
  color: #bebebe;
  text-align: center;
  font-weight: bold;
}
.progressbar li:after{
  content: '';
  position: absolute;
  width:100%;
  height: 3px;
  background: #979797;
  top: 15px;
  left: -50%;
  z-index: -1;
}
.progressbar li:first-child:before{
  border-color: #3aac5d;
  background: #3aac5d;
  color: white
}
.progressbar li:first-child:after{
  content: none;
  background: #3aac5d;
}
.progressbar li.active + li:after{
  background: #3aac5d;
}
.progressbar li.active + li:before{
  border-color: #3aac5d;
  background: #3aac5d;
  color: white
}
li {list-style-type: none;}
</style>